import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const LS_KEY = (uid) => `dashboard-layout-${uid}`;

export function loadLayoutLocal(uid) {
  try {
    const key = LS_KEY(uid);
    const raw = localStorage.getItem(key);
    console.log("[LS] loadLayoutLocal key:", key, "found:", !!raw);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveLayoutLocal(uid, layout, widgets) {
  try {
    const key = LS_KEY(uid);
    localStorage.setItem(key, JSON.stringify({ layout, widgets }));
    // Verify it was written
    const check = localStorage.getItem(key);
    console.log("[LS] saved to", key, "— readback length:", check?.length);
  } catch (e) {
    console.error("[LS] saveLayoutLocal FAILED", e);
  }
}

export async function loadLayout(uid, tenantId) {
  // localStorage first (instant).
  // Use local if it exists — even if widgets array is empty (user removed all widgets).
  const local = loadLayoutLocal(uid);
  if (local !== null) return local;
  // Firestore fallback
  try {
    const ref  = doc(db, "tenants", tenantId, "userPreferences", uid, "dashboard", "layout");
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    const data = snap.data();
    if (data.layout && data.widgets) saveLayoutLocal(uid, data.layout, data.widgets);
    return { layout: data.layout, widgets: data.widgets };
  } catch (e) {
    console.warn("loadLayout Firestore error:", e);
    return null;
  }
}

export async function saveLayout(uid, tenantId, layout, widgets) {
  // Strip undefined fields from layout items — Firestore rejects undefined values
  const cleanLayout = layout.map(({ i, x, y, w, h, minW, minH, maxW, maxH }) => {
    const item = { i, x, y, w, h };
    if (minW !== undefined) item.minW = minW;
    if (minH !== undefined) item.minH = minH;
    if (maxW !== undefined) item.maxW = maxW;
    if (maxH !== undefined) item.maxH = maxH;
    return item;
  });
  // Save to localStorage immediately
  saveLayoutLocal(uid, cleanLayout, widgets);
  // Sync to Firestore
  try {
    const ref = doc(db, "tenants", tenantId, "userPreferences", uid, "dashboard", "layout");
    await setDoc(ref, { layout: cleanLayout, widgets, updatedAt: new Date().toISOString() }, { merge: true });
  } catch (e) {
    console.warn("saveLayout Firestore error:", e);
  }
}

